/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Plan_NoneInputs */

const cs_billing_plan_none = /** @type {(inputs: Billing_Plan_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatím není nastavený tarif.`)
};

const en_billing_plan_none = /** @type {(inputs: Billing_Plan_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No plan assigned yet.`)
};

/**
* | output |
* | --- |
* | "No plan assigned yet." |
*
* @param {Billing_Plan_NoneInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_plan_none = /** @type {((inputs?: Billing_Plan_NoneInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Plan_NoneInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_plan_none(inputs)
	return cs_billing_plan_none(inputs)
});